//#region src/lib/squircle.ts
/**
* Figma 風スーパー楕円（コーナースムージング = 0.6）を clip-path で再現。
* 生成元(generator.html)の squirclePath / squircle / applySquircles をそのまま移植。
*/
function squirclePath(w, h, radius, smoothing) {
	const budget = Math.min(w, h) / 2;
	const r = Math.min(radius, budget);
	const p = Math.min((1 + smoothing) * r, budget);
	const rEff = (1 + smoothing) * r > budget ? budget / (1 + smoothing) : r;
	const rad = (d) => d * Math.PI / 180;
	const arcMeasure = 90 * (1 - smoothing);
	const arcLen = Math.sin(rad(arcMeasure / 2)) * rEff * Math.sqrt(2);
	const alpha = (90 - arcMeasure) / 2;
	const p3p4 = rEff * Math.tan(rad(alpha / 2));
	const beta = 45 * smoothing;
	const c = p3p4 * Math.cos(rad(beta));
	const d = c * Math.tan(rad(beta));
	const b = (p - arcLen - c - d) / 3;
	const a = 2 * b;
	const rr = rEff;
	const f = (x) => Math.round(x * 1e3) / 1e3;
	return "path('M " + f(w - p) + " 0 c " + f(a) + " 0 " + f(a + b) + " 0 " + f(a + b + c) + " " + f(d) + " a " + f(rr) + " " + f(rr) + " 0 0 1 " + f(arcLen) + " " + f(arcLen) + " c " + f(d) + " " + f(c) + " " + f(d) + " " + f(b + c) + " " + f(d) + " " + f(a + b + c) + " l 0 " + f(h - 2 * p) + " c 0 " + f(a) + " 0 " + f(a + b) + " " + f(-d) + " " + f(a + b + c) + " a " + f(rr) + " " + f(rr) + " 0 0 1 " + f(-arcLen) + " " + f(arcLen) + " c " + f(-c) + " " + f(d) + " " + f(-(b + c)) + " " + f(d) + " " + f(-(a + b + c)) + " " + f(d) + " l " + f(-(w - 2 * p)) + " 0 c " + f(-a) + " 0 " + f(-(a + b)) + " 0 " + f(-(a + b + c)) + " " + f(-d) + " a " + f(rr) + " " + f(rr) + " 0 0 1 " + f(-arcLen) + " " + f(-arcLen) + " c " + f(-d) + " " + f(-c) + " " + f(-d) + " " + f(-(b + c)) + " " + f(-d) + " " + f(-(a + b + c)) + " l 0 " + f(-(h - 2 * p)) + " c 0 " + f(-a) + " 0 " + f(-(a + b)) + " " + f(d) + " " + f(-(a + b + c)) + " a " + f(rr) + " " + f(rr) + " 0 0 1 " + f(arcLen) + " " + f(-arcLen) + " c " + f(c) + " " + f(-d) + " " + f(b + c) + " " + f(-d) + " " + f(a + b + c) + " " + f(-d) + " Z')";
}
function squircle(el, radius) {
	if (!el) return;
	const node = el;
	const w = node.offsetWidth;
	const h = node.offsetHeight;
	if (w < 2 || h < 2) return;
	const path = squirclePath(w, h, radius, .6);
	node.style.clipPath = path;
	node.style.webkitClipPath = path;
}
/** カード / 背景 / サムネ / メイン画像 / ナビパネルに角丸を適用。
*  perf: 計測(read)→書き込み(write) を2フェーズに分け、最大17要素の
*  offsetWidth 読みと clipPath 書きが交互に起きる強制同期レイアウトを解消する。 */
function applySquircles() {
	const targets = [];
	const isPc = window.innerWidth >= 1024;
	const cardR = isPc ? 56 : 32;
	const thumbR = isPc ? 32 : 20;
	document.querySelectorAll(".carousel .card-inner").forEach((c) => targets.push({
		el: c,
		r: cardR
	}));
	document.querySelectorAll(".carousel .thumb").forEach((c) => targets.push({
		el: c,
		r: thumbR
	}));
	document.querySelectorAll(".cp-banner").forEach((c) => targets.push({
		el: c,
		r: 24
	}));
	const photo = document.querySelector(".fv-photo");
	if (photo) targets.push({
		el: photo,
		r: window.innerWidth >= 1024 ? 40 : 32
	});
	const np = document.querySelector(".fv-nav-panel");
	if (np && np.offsetWidth > 2) targets.push({
		el: np,
		r: 28
	});
	const measured = targets.map((t) => ({
		el: t.el,
		r: t.r,
		w: t.el.offsetWidth,
		h: t.el.offsetHeight
	}));
	for (const m of measured) {
		if (m.w < 2 || m.h < 2) continue;
		const path = squirclePath(m.w, m.h, m.r, .6);
		m.el.style.clipPath = path;
		m.el.style.webkitClipPath = path;
	}
}
//#endregion
//#region src/lib/section.ts
/**
* セクションのクライアント挙動（生成元 generator.html の <script> から、
* フォーム/書き出し/端末プリセット/縮小プレビューを除いた実装版）。
*
* - カルーセル（5スロットのリング：farLeft/left/center/right/farRight）
* - Figma squircle（角丸）の適用
* - 背景の光（中央カード画像のアンビエント）
* - 出現アニメ（FV＝load時 / CONTENTS＝スクロールで IntersectionObserver）
* - ハンバーガーナビ開閉 / 言語切替ラベル / アナウンスを閉じる / CTA虹色ジッグル
*
* カードデータは index.astro が window.__SECTION_DATA__ に注入する。
*/
var cards = window.__SECTION_DATA__?.cards ?? [];
var $ = (s) => document.querySelector(s);
function pad(n) {
	return n < 10 ? "0" + n : "" + n;
}
function escapeHtml(s) {
	return String(s).replace(/[&<>"]/g, (c) => {
		return {
			"&": "&amp;",
			"<": "&lt;",
			">": "&gt;",
			"\"": "&quot;"
		}[c];
	});
}
function cardHTML(card) {
	return (card.image ? `<div class="thumb"><img src="${card.image}" alt=""></div>` : `<div class="thumb"><span class="noimg">画像未設定</span></div>`) + `<div class="card-text"><h4>${escapeHtml(card.title || "タイトル")}</h4><p>${escapeHtml(card.desc || "説明文がここに入ります。")}</p></div>`;
}
function fillSlot(slotEl, card) {
	if (!slotEl) return;
	const c = slotEl.querySelector(".card");
	const bg = slotEl.querySelector(".card-bg");
	if (c) c.innerHTML = cardHTML(card);
	if (bg) bg.style.backgroundImage = card.image ? `url("${card.image}")` : "none";
}
var current = 0;
var ring = null;
var POSKEYS = [
	"farLeft",
	"left",
	"center",
	"right",
	"farRight"
];
var OFFSETS = [
	-2,
	-1,
	0,
	1,
	2
];
function ringEls() {
	if (!ring) ring = [
		$("#slotFL"),
		$("#slotLeft"),
		$("#slotCenter"),
		$("#slotRight"),
		$("#slotFR")
	];
	return ring;
}
function fillAt(el, rawIdx) {
	const n = cards.length;
	if (!n) return;
	fillSlot(el, cards[(rawIdx % n + n) % n]);
}
function updatePill(idx) {
	const n = cards.length;
	const pill = $("#pvPill");
	if (!pill) return;
	pill.style.width = (n > 0 ? 100 / n : 100) + "%";
	pill.style.transform = "translate(" + idx * 100 + "%, -50%)";
}
function setCurDigit(val) {
	const box = $("#pvCur");
	if (!box) return;
	const d = box.querySelector(".digit");
	if (d) d.textContent = val;
	else box.innerHTML = "<span class=\"digit\">" + val + "</span>";
}
var animating = false;
var pending = 0;
var POS = {
	left: {
		rot: -3,
		s: .8,
		tilt: 0,
		o: .4,
		z: 1
	},
	center: {
		rot: 0,
		s: 1,
		tilt: 0,
		o: 1,
		z: 3
	},
	right: {
		rot: 3,
		s: .8,
		tilt: 0,
		o: .4,
		z: 1
	},
	farLeft: {
		rot: -6,
		s: .62,
		tilt: 0,
		o: 0,
		z: 0
	},
	farRight: {
		rot: 6,
		s: .62,
		tilt: 0,
		o: 0,
		z: 0
	}
};
function setPos(el, key, animate) {
	if (!el) return;
	const s = POS[key];
	const inner = el.querySelector(".card-inner");
	if (!animate) {
		el.style.transition = "none";
		if (inner) inner.style.transition = "none";
	}
	const isPc = window.innerWidth >= 1024;
	el.style.transform = "translateX(-50%) rotate(" + s.rot + "deg)";
	const sideDim = isPc && (key === "left" || key === "right") ? .3 : s.o;
	el.style.opacity = String(sideDim);
	el.style.zIndex = String(s.z);
	el.dataset.poskey = key;
	if (inner) {
		inner.style.transform = "scale(" + s.s + ") rotate(" + s.tilt + "deg)";
		if (isPc) {
			inner.style.filter = "";
			//el.style.filter = key === "center" ? "none" : "blur(8px)";
		} else {
			el.style.filter = "";
			//inner.style.filter = key === "center" ? "none" : "blur(6px)";
		}
	}
	if (!(key === "farLeft" || key === "farRight")) el.classList.remove("slot-faroff");
	else if (animate) window.setTimeout(() => {
		if (el.dataset.poskey === "farLeft" || el.dataset.poskey === "farRight") el.classList.add("slot-faroff");
	}, 640);
	else el.classList.add("slot-faroff");
	if (!animate) {
		el.offsetWidth;
		el.style.transition = "";
		if (inner) inner.style.transition = "";
	}
}
function layoutRest() {
	const r = ringEls();
	for (let i = 0; i < 5; i++) setPos(r[i], POSKEYS[i], false);
}
function updateCarouselHeight() {
	const cc = document.querySelector("#slotCenter .card");
	const car = $("#carousel");
	if (cc && car) car.style.height = cc.offsetHeight + "px";
}
var SIDE_SCALE = .8, TILT = 3, GAP = 24;
function updateOrbit() {
	const cc = document.querySelector("#slotCenter .card");
	if (!cc) return;
	const cardW = cc.offsetWidth, cardH = cc.offsetHeight;
	const halfC = cardW / 2, sideHalf = cardW * SIDE_SCALE / 2;
	const R = (halfC + GAP + sideHalf) / Math.sin(TILT * Math.PI / 180);
	const pivotY = Math.round(R + cardH / 2);
	document.querySelectorAll(".cstack").forEach((slot) => {
		slot.style.transformOrigin = "50% " + pivotY + "px";
	});
}
var glowImg = null;
var glowActive = "A";
function setGlow(img) {
	img = img || "";
	if (img === glowImg) return;
	glowImg = img;
	const inc = $(glowActive === "A" ? "#bgGlowB" : "#bgGlowA");
	const out = $(glowActive === "A" ? "#bgGlowA" : "#bgGlowB");
	if (inc) {
		inc.style.backgroundImage = img ? `url("${img}")` : "none";
		inc.style.opacity = img ? ".58" : "0";
	}
	if (out) out.style.opacity = "0";
	glowActive = glowActive === "A" ? "B" : "A";
}
var glowTimer = 0;
function scheduleGlow(img) {
	clearTimeout(glowTimer);
	glowTimer = window.setTimeout(() => setGlow(img), 50);
}
function positionGlow() {
	const host = document.querySelector(".stage-contents");
	const area = document.querySelector(".card-area");
	if (!host || !area) return;
	const y = area.offsetTop + area.offsetHeight / 2;
	document.querySelectorAll(".bg-glow").forEach((gl) => gl.style.top = y + "px");
}
function slide(dir) {
	const n = cards.length;
	if (n <= 1) return;
	if (animating) {
		pending = dir;
		return;
	}
	animating = true;
	const nextCur = (current + dir + n) % n;
	const target = cards[nextCur];
	scheduleGlow(target ? target.image : "");
	updatePill(nextCur);
	setCurDigit(pad(nextCur + 1));
	const r = ringEls();
	let recycled;
	if (dir > 0) {
		recycled = r[0];
		fillAt(recycled, current + 3);
		r.push(r.shift());
	} else {
		recycled = r[4];
		fillAt(recycled, current - 3);
		r.unshift(r.pop());
	}
	for (let i = 0; i < 5; i++) setPos(r[i], POSKEYS[i], r[i] !== recycled);
	current = nextCur;
	requestAnimationFrame(() => {
		applySquircles();
		positionGlow();
	});
	setTimeout(() => {
		animating = false;
		if (pending) {
			const p = pending;
			pending = 0;
			slide(p);
		}
	}, 540);
}
function renderCarousel() {
	const n = cards.length;
	if (current >= n) current = n - 1;
	if (current < 0) current = 0;
	const card = cards[current] || {
		title: "",
		desc: "",
		image: ""
	};
	const tot = $("#pvTot");
	if (tot) tot.textContent = pad(n);
	if (!animating) setCurDigit(pad(current + 1));
	const r = ringEls();
	for (let i = 0; i < 5; i++) fillAt(r[i], current + OFFSETS[i]);
	setGlow(card.image);
	updatePill(current);
	requestAnimationFrame(() => {
		applySquircles();
		updateCarouselHeight();
		updateOrbit();
		positionGlow();
		if (!animating) layoutRest();
	});
}
function resync() {
	applySquircles();
	updateCarouselHeight();
	updateOrbit();
	positionGlow();
	if (!animating) layoutRest();
}
function updateCardScale() {
	const card = document.querySelector(".pr-card");
	if (!card || card.clientWidth < 2) return;
	card.style.setProperty("--cardScale", String(card.clientWidth / 358));
}
function revealOnScroll(el, cls, margin = "0px 0px -28% 0px") {
	if (!el) return;
	if (!("IntersectionObserver" in window)) {
		el.classList.add(cls);
		return;
	}
	const io = new IntersectionObserver((entries) => {
		for (const e of entries) if (e.isIntersecting) {
			el.classList.add(cls);
			io.disconnect();
		}
	}, {
		root: null,
		rootMargin: margin,
		threshold: 0
	});
	io.observe(el);
}
function bindNav() {
	const nav = $("#fvNav");
	const device = document.querySelector(".device");
	const open = () => {
		if (!nav) return;
		nav.classList.add("open");
		nav.setAttribute("aria-hidden", "false");
		device?.classList.add("nav-open");
		const p = document.querySelector(".fv-nav-panel");
		if (p) requestAnimationFrame(() => squircle(p, 28));
	};
	const close = () => {
		if (!nav) return;
		// aria-hidden を付ける前に、内部にフォーカスが残っていれば外す。
		// フォーカスが残ったまま aria-hidden を付けると、ブラウザが強制的に
		// フォーカスを移動させる安全処理を行い、その副作用でスクロール位置が
		// リセットされてしまう（アンカー着地位置がズレる不具合の実体）。
		if (nav.contains(document.activeElement)) {
			document.activeElement.blur();
		}
		nav.classList.remove("open");
		nav.setAttribute("aria-hidden", "true");
		device?.classList.remove("nav-open");
	};
	$("#fvBurger")?.addEventListener("click", open);
	$("#fvNavClose")?.addEventListener("click", close);
	$("#fvNavBackdrop")?.addEventListener("click", close);
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") close();
	});
	// アンカーリンク（CONTENTS/BENEFITS/PRICE/BwithU）をクリックしたらメニューを閉じる。
	document.querySelectorAll(".fv-nav-item").forEach((item) => {
		item.addEventListener("click", close);
	});
}
/*
  アンカーリンクのスクロール位置をJSで制御する。
  この環境では CSS の scroll-margin-top が scrollIntoView / 通常の
  アンカー遷移のどちらでも尊重されないため、マージンに頼らない方式にする。

  手順：
    1. まず「即時」で scrollIntoView させ、実際にどこまでスクロールしたかを
       ブラウザ自身に判定させる（＝この環境で実際に動くスクロールコンテナを
       自前で推測する必要がない）
    2. 一旦スクロール位置を元に戻す
    3. 固定ヘッダー（.fv-fixedtop）の実測高さぶんだけ引いた位置へ、
       改めて滑らかにスクロールする
*/
function getFixedHeaderOffset() {
	if (window.innerWidth >= 1024) return 0;   // PCは固定ヘッダーがコンテンツに重ならない
	const header = document.querySelector(".fv-fixedtop");
	if (!header) return 0;
	const EXTRA = 16;   // 気持ち多めの余白
	return header.getBoundingClientRect().height + EXTRA;
}
function scrollToAnchor(id, updateHash) {
	const target = document.getElementById(id);
	if (!target) return;

	// html が実際のスクロール要素であることを確認済みのため、
	// getBoundingClientRect（常にビューポート基準で正確）と現在の scrollTop から
	// 目的の位置を一度で計算する（scrollTopへの連続書き込みは
	// scroll-behavior: smooth のアニメーションと競合するため避ける）。
	const htmlEl = document.documentElement;
	const offset = getFixedHeaderOffset();
	const to = Math.max(
		0,
		target.getBoundingClientRect().top + htmlEl.scrollTop - offset
	);

	htmlEl.scrollTop = to;

	if (updateHash && history.pushState) history.pushState(null, "", "#" + id);
}
function bindAnchorNav() {
	document.querySelectorAll('a[href^="#"]').forEach((link) => {
		const hash = link.getAttribute("href");
		if (!hash || hash.length < 2) return;
		const id = hash.slice(1);
		if (!document.getElementById(id)) return;
		link.addEventListener("click", (event) => {
			event.preventDefault();
			// クリックに伴う後続処理（メニューを閉じる際のレイアウト変化など）が
			// 完全に落ち着いてから位置を計算する。同じフレーム内で計算すると、
			// 後続のレイアウト変化にブラウザの scroll anchoring 等が反応して
			// 位置がずれ直す可能性があるため、2フレーム分待つ。
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					scrollToAnchor(id, true);
				});
			});
		});
	});
}
function bindLang() {
	const localePrefixes = ["/en", "/ko", "/zh-hant", "/zh-hans", "/vi", "/id", "/ms", "/th"];

	const switchLocale = (prefix) => {
		let path = window.location.pathname || "/";
		for (const localePrefix of localePrefixes) {
			if (path === localePrefix || path.startsWith(localePrefix + "/")) {
				path = path.slice(localePrefix.length) || "/";
				break;
			}
		}
		const nextPath = (prefix || "") + (path.startsWith("/") ? path : "/" + path);
		window.location.href = nextPath + window.location.search + window.location.hash;
	};

	const pcSel = $("#pcfvLangSelect");
	const pcLabel = $("#pcfvLangLabel");
	if (pcSel && pcLabel) {
		const currentPath = window.location.pathname || "/";
		const selected = Array.from(pcSel.options).find((option) => {
			const prefix = option.dataset.prefix || "";
			return prefix ? currentPath === prefix || currentPath.startsWith(prefix + "/") : !localePrefixes.some((p) => currentPath === p || currentPath.startsWith(p + "/"));
		});
		if (selected) {
			selected.selected = true;
			pcLabel.textContent = selected.value;
		}
		pcSel.addEventListener("change", () => {
			const option = pcSel.options[pcSel.selectedIndex];
			pcLabel.textContent = option.value;
			switchLocale(option.dataset.prefix || "");
		});
	}

	document.querySelectorAll("#fvLangMenu [data-prefix]").forEach((button) => {
		button.addEventListener("click", () => switchLocale(button.dataset.prefix || ""));
	});
}
function bindAnnounceClose() {
	const close = $("#fvAnnoClose");
	const device = document.querySelector(".device");
	if (!close) return;
	close.addEventListener("click", () => {
		if (device) device.classList.remove("has-announce");
	});
}
function bindAnnounceHeight() {
	const device = document.querySelector(".device");
	const bar = $("#fvAnnounce");
	if (!device) return;
	const sync = () => {
		const h = bar && device.classList.contains("has-announce") ? bar.offsetHeight : 0;
		device.style.setProperty("--announceH", h + "px");
	};
	sync();
	if (bar && "ResizeObserver" in window) new ResizeObserver(sync).observe(bar);
	$("#fvAnnoClose")?.addEventListener("click", () => requestAnimationFrame(sync));
	if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
}
var jiggleTimer = null;
var rbBlobs = null;
function rbJiggleOnce() {
  if (!rbBlobs || !rbBlobs.length) return;

  const movementRanges = [
    { min: -20, max: 110 },
    { min: -70, max: 90 },
    { min: -100, max: 80 },
    { min: -80, max: 100 },
    { min: -90, max: 70 },
    { min: -110, max: 20 }
  ];

  rbBlobs.forEach((blob, index) => {
    const range = movementRanges[index] || { min: -70, max: 70 };

    const x =
      range.min + Math.random() * (range.max - range.min);

    const y = Math.random() * 40 - 20;
    const scaleX = 0.8 + Math.random() * 0.7;
    const scaleY = 0.85 + Math.random() * 0.55;
    const rotate = Math.random() * 30 - 15;

    blob.style.transform = `
      translate3d(
        ${x}px,
        calc(-50% + ${y}px),
        0
      )
      scale(${scaleX}, ${scaleY})
      rotate(${rotate}deg)
    `;
  });
}
function rbStart() {
	if (jiggleTimer != null) return;
	rbJiggleOnce();
	jiggleTimer = window.setInterval(rbJiggleOnce, 2400);
}
function rbStop() {
	if (jiggleTimer != null) {
		clearInterval(jiggleTimer);
		jiggleTimer = null;
	}
}
var fvCtaVisible = true;
function refreshAnim() {
	const device = document.querySelector(".device");
	if (!device) return;
	const stickyShown = device.classList.contains("show-cta");
	const paused = !fvCtaVisible && !stickyShown || document.hidden;
	device.classList.toggle("anim-paused", paused);
	if (paused) rbStop();
	else rbStart();
}
function bindIdlePause() {
	rbBlobs = document.querySelectorAll(".rainbow-btn .rb-color");
	const cta = document.querySelector(".fv-cta-area");
	if (cta && "IntersectionObserver" in window) new IntersectionObserver((entries) => {
		for (const e of entries) fvCtaVisible = e.isIntersecting;
		refreshAnim();
	}, {
		root: null,
		threshold: 0
	}).observe(cta);
	document.addEventListener("visibilitychange", refreshAnim);
	refreshAnim();
}
function bindStickyCta() {
	const device = document.querySelector(".device");
	const contents = document.querySelector(".stage-contents");
	const campaign = document.querySelector(".campaign");
	if (!device || !contents) return;
	let ticking = false;
	const update = () => {
		ticking = false;
		const pcTrigger = window.innerWidth >= 1024 ? campaign : null;
		const show = pcTrigger ? pcTrigger.getBoundingClientRect().top <= window.innerHeight * .5 : contents.getBoundingClientRect().top <= window.innerHeight * .2;
		if (show !== device.classList.contains("show-cta")) {
			device.classList.toggle("show-cta", show);
			refreshAnim();
		}
	};
	window.addEventListener("scroll", () => {
		if (!ticking) {
			ticking = true;
			requestAnimationFrame(update);
		}
	}, { passive: true });
	window.addEventListener("resize", () => requestAnimationFrame(update), { passive: true });
	update();
}
function bindPcfvScroll() {
	const btn = document.getElementById("pcfvScroll");
	if (!btn) return;
	btn.addEventListener("click", () => {
		(document.querySelector(".campaign") ?? document.querySelector(".stage-contents"))?.scrollIntoView({
			behavior: "smooth",
			block: "start"
		});
	});
}
function bindSwipe() {
	const area = document.querySelector("#carousel");
	if (!area) return;
	area.style.touchAction = "pan-y";
	let startX = 0, startY = 0, tracking = false;
	const THRESH = 16;
	area.addEventListener("pointerdown", (e) => {
		startX = e.clientX;
		startY = e.clientY;
		tracking = true;
	}, { passive: true });
	area.addEventListener("pointerup", (e) => {
		if (!tracking) return;
		tracking = false;
		const dx = e.clientX - startX;
		const dy = e.clientY - startY;
		if (Math.abs(dx) > THRESH && Math.abs(dx) > Math.abs(dy)) {
			slide(dx < 0 ? 1 : -1);
			return;
		}
		if (window.innerWidth >= 1024 && Math.abs(dx) <= THRESH && Math.abs(dy) <= THRESH) sideCardGo(e.target);
	}, { passive: true });
	area.addEventListener("click", (e) => {
		if (window.innerWidth < 1024) return;
		if (performance.now() - lastSideGoAt < 500) return;
		sideCardGo(e.target);
	});
	area.addEventListener("pointercancel", () => {
		tracking = false;
	});
}
var lastSideGoAt = 0;
function sideCardGo(target) {
	const key = (target?.closest?.(".cstack"))?.dataset.poskey;
	if (key !== "left" && key !== "right") return;
	lastSideGoAt = performance.now();
	slide(key === "left" ? -1 : 1);
}
function bindBwuStack() {
	const stack = document.getElementById("bwuStack");
	if (!stack) return;
	const cards = Array.from(stack.querySelectorAll(".bwu-card"));
	if (cards.length < 2) return;
	let ticking = false;
	const update = () => {
		ticking = false;
		if (window.innerWidth < 1024) {
			cards.forEach((c) => {
				c.style.transform = "";
				c.style.filter = "";
			});
			return;
		}
		for (let i = 0; i < cards.length - 1; i++) {
			const h = cards[i].offsetHeight;
			const pinTop = (window.innerHeight - h) / 2;
			const nextTop = cards[i + 1].getBoundingClientRect().top;
			const p = Math.min(1, Math.max(0, (pinTop + h - nextTop) / h));
			if (p <= 0) {
				cards[i].style.transform = "";
				cards[i].style.filter = "";
				continue;
			}
			cards[i].style.transform = "perspective(1200px) translateY(" + (-28 * p).toFixed(1) + "px) rotateX(" + (9 * p).toFixed(2) + "deg) scale(" + (1 - .12 * p).toFixed(4) + ")";
			cards[i].style.filter = "brightness(" + (1 - .45 * p).toFixed(3) + ")";
		}
	};
	const onScroll = () => {
		if (!ticking) {
			ticking = true;
			requestAnimationFrame(update);
		}
	};
	window.addEventListener("scroll", onScroll, { passive: true });
	window.addEventListener("resize", onScroll, { passive: true });
	update();
}
function bindFooterFade() {
  const appBox = document.querySelector(".pcfv-app");
  const footer = document.querySelector(".bwithu-footer");
  if (!appBox || !footer) return;

  if (!("IntersectionObserver" in window)) return;

  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries) {
        // フッターが画面に近づいてきたら（見え始めたら）隠す
        appBox.classList.toggle("is-hidden", e.isIntersecting);
      }
    },
    {
      root: null,
      // フッターの上端が画面下から少し手前（appBoxの高さ分くらい）に来た時点で
      // 先んじてフェードアウトさせておく（重なり防止のバッファ）
      rootMargin: "0px 0px -200px 0px",
      threshold: 0,
    }
  );

  io.observe(footer);
}
function bindFaq() {
  const faqItems = document.querySelectorAll('[data-faq-item]');

  if (!faqItems.length) return;

  faqItems.forEach(function (item) {
    const button = item.querySelector('.faq-q');
    const answer = item.querySelector('.faq-answer');

    if (!button || !answer) return;

    button.addEventListener('click', function () {
      const isOpen = item.classList.contains('active');

      if (isOpen) {
        closeFaq(item, button, answer);
      } else {
        openFaq(item, button, answer);
      }
    });
  });

  function openFaq(item, button, answer) {
    item.classList.add('active');
    button.setAttribute('aria-expanded', 'true');

    answer.style.visibility = 'visible';
    answer.style.height = '0px';

    requestAnimationFrame(function () {
      answer.style.height = answer.scrollHeight + 'px';
    });

    function handleOpened(event) {
      if (event.propertyName !== 'height') return;

      answer.style.height = 'auto';
      answer.removeEventListener('transitionend', handleOpened);
    }

    answer.addEventListener('transitionend', handleOpened);
  }

  function closeFaq(item, button, answer) {
    answer.style.height = answer.scrollHeight + 'px';

    answer.offsetHeight;

    item.classList.remove('active');
    button.setAttribute('aria-expanded', 'false');

    requestAnimationFrame(function () {
      answer.style.height = '0px';
    });

    function handleClosed(event) {
      if (event.propertyName !== 'height') return;

      answer.style.visibility = 'hidden';
      answer.removeEventListener('transitionend', handleClosed);
    }

    answer.addEventListener('transitionend', handleClosed);
  }
}
function bindRainbowButtons() {
  document.querySelectorAll(".rainbow-btn").forEach((btn) => {
    const colors = btn.querySelector(".rb-colors");
    if (!colors) return;
    const swatches = colors.querySelectorAll(".rb-color");
    if (!swatches.length) return;

    let intervalId = null;

    const randomTranslate = () => {
      const x = Math.floor(Math.random() * 100 - 50);
      const y = Math.floor(Math.random() * 100 - 50);
      return `translate(${x}%, ${y}%)`;
    };

    const randomize = () => {
      swatches.forEach((s) => {
        s.style.transform = randomTranslate();
      });
    };

    const stop = () => {
      if (intervalId !== null) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };

    const start = () => {
      stop();
      setTimeout(randomize, 100);
      intervalId = window.setInterval(randomize, 1500);
    };

    start();
  });
}
function bindFooterMagnetic() {
  const hero = document.querySelector(".bwithu-hero");
  if (!hero) return;

  let raf = 0;

  const onMove = (e) => {
    const rect = hero.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const x = (e.clientX - cx) / (rect.width / 2);
    const y = (e.clientY - cy) / (rect.height / 2);

    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => {
      hero.style.setProperty("--x", String(Math.max(-1, Math.min(1, x))));
      hero.style.setProperty("--y", String(Math.max(-1, Math.min(1, y))));
    });
  };

  const onLeave = () => {
    hero.style.setProperty("--x", "0");
    hero.style.setProperty("--y", "0");
  };

  hero.addEventListener("mousemove", onMove);
  hero.addEventListener("mouseleave", onLeave);
}
function bindFooterTrail() {
  const wrap = document.querySelector(".bwithu-footer-trail-wrap");
  const trail = document.querySelector(".bwithu-footer-trail");
  if (!wrap || !trail) return;

  const items = Array.from(trail.querySelectorAll(".bwithu-footer-trail-item"));
  if (!items.length) return;

  let index = 0;
  let lastX = 0, lastY = 0;
  let lastSpawn = 0;
  const MIN_DIST = 60;    // これ以上動いたら次の画像を出す
  const MIN_INTERVAL = 80; // ms

  wrap.addEventListener("mousemove", (e) => {
    const rect = wrap.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const dist = Math.hypot(x - lastX, y - lastY);
    const now = performance.now();
    if (dist < MIN_DIST || now - lastSpawn < MIN_INTERVAL) return;

    lastX = x;
    lastY = y;
    lastSpawn = now;

    const img = items[index % items.length];
    index++;

    img.style.transition = "none";
    img.style.opacity = "0";
    img.style.transform = `translate(${x}px, ${y}px) scale(0.8)`;

    // 強制リフロー後にフェードイン→アウト
    void img.offsetWidth;
    img.style.transition = "opacity 0.4s ease, transform 0.6s ease";
    img.style.opacity = "1";
    img.style.transform = `translate(${x}px, ${y}px) scale(1)`;

    window.setTimeout(() => {
      img.style.opacity = "0";
    }, 500);
  });
}
function bindFooterParallax() {
  const el = document.querySelector(".bwithu-footer-inner");
  if (!el) return;

  const FACTOR = 0.06; // 動く量。移植元の0.1相当を少し弱めた値
  let ticking = false;

  const update = () => {
    ticking = false;
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight;
    // ビューポート中央からの距離に応じてズラす
    const progress = (vh - rect.top) / (vh + rect.height);
    const offset = (progress - 0.5) * 100 * FACTOR;
    el.style.transform = `translateY(${offset}px)`;
  };

  window.addEventListener("scroll", () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });

  update();
}
function bindFooterNoise() {
  const container = document.querySelector("[data-footer-noise]");
  if (!container) return;

  const canvas = document.createElement("canvas");
  canvas.width = 128;
  canvas.height = 128;
  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  const imageData = ctx.createImageData(128, 128);
  for (let i = 0; i < imageData.data.length; i += 4) {
    const v = Math.floor(Math.random() * 255);
    imageData.data[i] = v;
    imageData.data[i + 1] = v;
    imageData.data[i + 2] = v;
    imageData.data[i + 3] = 12; // 薄いノイズ
  }
  ctx.putImageData(imageData, 0, 0);

  container.style.backgroundImage = `url(${canvas.toDataURL()})`;
  container.style.backgroundRepeat = "repeat";
  container.style.opacity = "0.5";
  container.style.mixBlendMode = "overlay";
}
function init() {
	renderCarousel();
	bindBwuStack();
	$("#prev")?.addEventListener("click", () => slide(-1));
	$("#next")?.addEventListener("click", () => slide(1));
	document.addEventListener("keydown", (e) => {
		const t = e.target;
		if (t && t.matches("input, textarea, select")) return;
		if (e.key === "ArrowLeft") slide(-1);
		if (e.key === "ArrowRight") slide(1);
	});
	revealOnScroll(document.querySelector(".campaign"), "is-rev", "0px 0px -30% 0px");
	revealOnScroll(document.querySelector(".stage-contents"), "cs-revealed");
	revealOnScroll(document.querySelector(".p-head-wrap"), "is-rev", "0px 0px -20% 0px");
	revealOnScroll(document.querySelector(".card-area"), "is-rev", "0px 0px -20% 0px");
	revealOnScroll(document.querySelector(".pager"), "is-rev", "0px 0px -10% 0px");
	revealOnScroll(document.querySelector(".bf-head-wrap"), "is-rev", "0px 0px -25% 0px");
	revealOnScroll(document.querySelector(".bf-cards"), "is-rev", "0px 0px -45% 0px");
	revealOnScroll(document.querySelector(".bf-more-text"), "is-rev", "0px 0px 0px 0px");
	revealOnScroll(document.querySelector(".bf-grid"), "is-rev", "0px 0px 0px 0px");
	revealOnScroll(document.querySelector(".price"), "is-rev", "0px 0px -45% 0px");
	revealOnScroll(document.querySelector(".bwu-intro"), "is-rev", "0px 0px -30% 0px");
	document.querySelectorAll(".bwu-card").forEach((c) => revealOnScroll(c, "is-rev", "0px 0px -65% 0px"));
	revealOnScroll(document.querySelector(".faq"), "is-rev", "0px 0px -25% 0px");
	bindAnchorNav();
	bindNav();
	bindLang();
	bindAnnounceClose();
	bindAnnounceHeight();
	bindIdlePause();
	bindStickyCta();
	bindPcfvScroll();
	bindFooterFade();
	bindSwipe();
	bindRainbowButtons();
	bindFooterMagnetic();
	//bindFooterTrail();
	bindFooterParallax();
	bindFooterNoise();
	updateCardScale();
	bindFaq();
	window.addEventListener("resize", () => requestAnimationFrame(updateCardScale), { passive: true });
	let resizeT = 0;
	window.addEventListener("resize", () => {
		clearTimeout(resizeT);
		resizeT = window.setTimeout(() => requestAnimationFrame(resync), 120);
	});
	if ("ResizeObserver" in window) {
		const card = $("#card");
		if (card) {
			let roScheduled = false;
			new ResizeObserver(() => {
				if (animating || roScheduled) return;
				roScheduled = true;
				requestAnimationFrame(() => {
					roScheduled = false;
					resync();
				});
			}).observe(card);
		}
	}
	if (document.fonts && document.fonts.ready) document.fonts.ready.then(resync);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
else init();
//#endregion
